import { render, staticRenderFns } from "./UserFieldTypeOptionsEdit.vue?vue&type=template&id=704a7204&"
import script from "./UserFieldTypeOptionsEdit.vue?vue&type=script&lang=js&"
export * from "./UserFieldTypeOptionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports